import { CertificatesList, CertificatesSettings } from '.';

const Certificates = () => (
  <div className="certificates">
    <div className="settings">
      <CertificatesSettings />
    </div>

    <div className="templates">
      <CertificatesList />
    </div>

    <style jsx>{`
      .templates {
        margin-top: 20px;
      }
    `}</style>
  </div>
);

export default Certificates;
